module.exports = __webpack_public_path__ + "assets/img/901132a9dcb99ad221129371fbb8ec58.svg";